export const BASE_PATH = '/citizen-passport'

export enum PathType {
    CREATE = 'citizenPassportCreate',
    SUMMARY = 'citizenPassportSummary'
}
